import { senecColors } from "src/styles/senecBaseThemePalette";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecDataGridTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            root: {
                border: 0,
                fontFamily: "EnBW DIN Pro, sans-serif",
                weight: "400",
                fontSize: "14px",
                lineHeight: "21px",
                "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    lineHeight: "inherit",
                    borderBottom: `1px solid ${theme.palette.neutralGray00.main}`,
                    borderTop: `none`,
                },
                "& .MuiDataGrid-row--lastVisible": {
                    "& .MuiDataGrid-cell": {
                        borderBottom: `none`,
                    },
                },
            },
            columnHeader: {
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                weight: "500",
                fontSize: "14px",
                lineHeight: "21px",
                paddingLeft: "16px",
                paddingRight: "16px",
                borderBottom: `none`,
                "&.MuiDataGrid-withBorderColor": {
                    borderBottom: `1px solid ${theme.palette.neutralGray00.main}`,
                    "&:focus, &:focus-within": {
                        outline: "none",
                    },
                },
            },
            columnHeaderCheckbox: {
                paddingLeft: "0px",
                paddingRight: "0px",
            },
            columnHeaderTitleContainer: {
                display: "flex",
                justifyContent: "space-between",
            },
            iconButtonContainer: {
                "& .MuiIconButton-root": {
                    color: theme.palette.neutralGray100.main,
                },
            },
            row: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                weight: "200",
                fontSize: "14px",
                lineHeight: "21px",
                "&:hover": {
                    backgroundColor: theme.palette.neutralGray000.main,
                },
                "&.Mui-selected": {
                    backgroundColor: theme.palette.neutralGray05.main,
                    "&:hover": {
                        backgroundColor: theme.palette.neutralGray000.main,
                    },
                },
            },
            cell: {
                minHeight: "46px",
                height: "auto",
                padding: "12px 16px",
                "&:focus, &:focus-within": {
                    outline: "none",
                },
            },
            footerContainer: {
                borderTop: "none",
                borderBottom: "none",
            },
            overlay: {
                fontSize: "14px",
            },
            virtualScroller: {
                minHeight: "80px",
            },
            selectedRowCount: {
                fontSize: "14px",
                backgroundColor: senecColors.deepBlue,
                color: senecColors.white,
                padding: "12px 12px",
                fontFamily: "EnBW DIN Pro Medium, sans-serif",
                weight: "500",
                lineHeight: "21px",
                borderRadius: "0.75rem",
            },
            menu: {
                list: {
                    fontSize: "14px",
                },
            },
            filterForm: {
                label: {
                    display: "none",
                },
            },
            filterFormColumnInput: {
                marginRight: "8px",
            },
            filterFormOperatorInput: {
                marginRight: "8px",
            },
        },
    };
};
